import { Box, Card } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';
import { observer } from 'mobx-react-lite';
import CurrentStatusSection from './current-status-section';
import RestaurantRiskSection from './restaurant-risk-section';
import type DashboardsDataStore from './dashboards-data-state';

type Props = Readonly<{
    /** 数据看板 Store，提供当前状态与风控数据 */
    store: DashboardsDataStore;
    /** 外层包裹 Box 的 sx（含响应式宽度），与已结/未结分析主卡对齐 */
    cardOuterSx: SxProps<Theme>;
}>;

/**
 * 当前营业状态 + 餐厅风控组合卡片
 * 仅负责渲染左侧卡片内容，时间段筛选由父页面统一承载
 */
const CurrentStatusAndRiskCard = observer((props: Props) => {
    const { store, cardOuterSx } = props;
    /** 风控项数量合计，为 0 时不展示餐厅风控区块 */
    const riskTotal = store.riskItems.reduce((sum, item) => sum + item.count, 0);

    return (
        <Box sx={cardOuterSx}>
            <Card
                sx={{
                    padding: '24px 16px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '16px',
                    borderRadius: '16px',
                    boxSizing: 'border-box',
                }}
            >
                <CurrentStatusSection data={store.currentStatusData} />
                {riskTotal > 0 && (
                    <>
                        <Box sx={{ borderBottom: '1px dashed var(--stroke-neutral-800-a25)', my: 1 }} />
                        <RestaurantRiskSection items={store.riskItems} />
                    </>
                )}
            </Card>
        </Box>
    );
});

export default CurrentStatusAndRiskCard;
